import { Button, Link } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';

const LandingBackButton = ({
    isFromMitTopdanmark,
    handleClick
}: {
    isFromMitTopdanmark: boolean;
    handleClick?: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const fromMitTopdanmarkText = getHippoText('DSS-LANDING-PAGE-BACK');
    const notFromMitTopdanmarkText = getHippoText('DSS-LANDING-PAGE-GO-TO-FRONT-PAGE');
    const goToInsuranceListPage = (): void => {
        window.location.href = '/';
    };
    return (
        <div className="u-flex-box u-flex-box--center u-gap-3 Section-offset-container">
            <Button
                theme="secondary"
                iconShape="arrow-left"
                onClick={handleClick ?? goToInsuranceListPage}
            />
            <Link className="u-color-primary-2-dark" onClick={handleClick ?? goToInsuranceListPage}>
                <div>{isFromMitTopdanmark ? fromMitTopdanmarkText : notFromMitTopdanmarkText}</div>
            </Link>
        </div>
    );
};

export default LandingBackButton;
